import React from 'react';
import './style.less';

const clsPrefix = "md-form-item";
const FormItem:React.FC<{
  title: string,
  children: React.ReactNode,
  tip?:string
}> = ({
  title,
  children,
  tip
}) => {
  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__main`}>
        <div className={`${clsPrefix}__title`}>{title}：</div>
        {children}
      </div>
      {
        tip && (
          <div className={`${clsPrefix}__tip`}>*{tip}</div>
        )
      }
    </div>
  )
}

export default FormItem;